<template>
  <BusinessCelebrityBlock
    :data="items"
    :title="data.title"
    chapter="celebrities"
    :chapter-id="data.id"
    :analytics="analytics"
  />
</template>

<script lang="ts" setup>
import { PrimaryContentDTO, CelebrityDTO } from '~/restAPI/data-contracts';

const props = defineProps<{
  data: PrimaryContentDTO
}>();

const items = computed(() => (props.data.contentList ?? []) as CelebrityDTO[]);

const analytics = computed(() => ({
  chapter: props.data.contentType,
  chapter_index: props.data.chapterIndex,
  segment_id: props.data.segmentId,
  id_chapter: props.data.id,
}));
</script>
